// extracted by mini-css-extract-plugin
export default {"tituloOutrosPosts":"Post_tituloOutrosPosts__MVW3A","postsRecomendados":"Post_postsRecomendados__RLLkF"};